import React from 'react'
// libs
import { useSelector } from 'react-redux'
// containers
import StrategyActionsContainer from 'containers/StrategyActions'
// store
import { isDashboardEditSelector, Widget } from 'store/reducers/dashboards'
// views
import { Wrapper, WidgetTitle } from './views'

interface Props {
  data: Widget
}

const StrategyActions: React.FC<Props> = ({ data }) => {
  const isEdit = useSelector(isDashboardEditSelector)

  const { showTitle } = data.item?.settings || {}

  return (
    <Wrapper disabled={isEdit}>
      {showTitle && <WidgetTitle>Strategy Actions</WidgetTitle>}
      {!isEdit && <StrategyActionsContainer />}
    </Wrapper>
  )
}

export default StrategyActions
